import React from 'react';

class Help extends React.PureComponent {
	render() {
		if (this.props.active) {
			var contacts = []
			for (var contact of this.props.data.Help.contacts) {
				contacts.push(
					<div key={contact.data}>
						<strong style={{ color: "#5f6062" }}>{contact.method + ': '}</strong>{contact.value}<br />
					</div>
				)
			}

			var documents = []
			for (var document of this.props.data.Help.documents) {
				documents.push(
					<div key={document.display}>
						<a target="_blank" rel="noopener noreferrer" href={document.path}><div className="helpRow">{document.display}</div></a>
					</div>
				)
			}

			return (
				<div className="viewContent">
					<div style={{ border: "1px solid #888", padding: "15px", marginRight: "8px" }}>
						<h3 style={{ color: "#5f6062" }}>Contact Technical Support - {this.props.data.Help.support}</h3>
						{contacts}
						<br />
					</div>

					<br />

					<div id="helpBox">
						{documents}
					</div>

				</div>
			);
		} else {
			return (
				<div width="100%">

				</div>
			)
		}
	}
}

const icon = "menuHelp"
const roles = ["View"]
export { Help, icon, roles }
